import { flexStyle, gridStyle, textStyle } from '@themes/mixins';
import styled, { css } from 'styled-components';

import Button from '../../../Button';

export const Container = styled.div`
  ${flexStyle({ direction: 'column', justify: 'flex-start', wrap: 'nowrap' })};
  background-color: ${({ theme }) => theme.colors.secondaryBackground};
  border-radius: 8px;
`;
export const Body = styled.div`
  ${flexStyle({ direction: 'column', justify: 'flex-start', wrap: 'nowrap' })};
  border: 1px solid ${({ theme }) => theme.colors.divider};
  padding: 16px 12px;
  border-radius: 6px;
`;
export const RowsContainer = styled.div<{
  columnCount: number;
  fullRowMode?: boolean;
}>`
  flex: 1;

  ${({ columnCount, fullRowMode }) =>
    fullRowMode
      ? css`
          ${flexStyle({
            direction: 'column',
            justify: 'flex-start',
            wrap: 'nowrap',
          })};
          gap: 30px;
        `
      : css`
          ${gridStyle({
            columnGap: 16,
            rowGap: 12,
            columns: columnCount,
            rows: 1,
          })};
        `}
`;
export const Row = styled.div`
  ${flexStyle({
    direction: 'row',
    justify: 'flex-start',
    align: 'start',
    wrap: 'nowrap',
  })};
`;
export const FieldsContainer = styled.div<{ columnCount: number }>`
  flex: 1;

  ${({ columnCount }) => css`
    ${gridStyle({ columnGap: 8, columns: columnCount, rows: 1 })};
  `}
`;
export const FullRowFieldsGrid = styled.div<{ columnCount: number }>`
  display: grid;
  grid-template-columns: ${({ columnCount }) => `repeat(${columnCount}, 1fr)`};
  column-gap: 8px;
  row-gap: 8px;
  flex: 1;
`;
export const FieldGridItem = styled.div<{ span: number }>`
  grid-column: span ${({ span }) => span};
  align-self: start;
`;
export const ButtonsContainer = styled.div`
  ${flexStyle({
    direction: 'row',
    justify: 'flex-start',
    align: 'center',
    wrap: 'nowrap',
  })};
  margin-top: 16px;
`;
export const Label = styled.label`
  ${flexStyle({ align: 'center', wrap: 'nowrap' })};
  ${textStyle({
    color: 'textPrimary',
    lineHeight: 1,
    size: '16px',
    textAlign: 'left',
    weight: 400,
  })};
  margin-bottom: 12px;
  letter-spacing: 0.5px;
`;
export const StyledDeleteButton = styled(Button)`
  color: ${({ theme }) => theme.colors.red};
  margin-left: 2px;
`;
export const StyledAddButton = styled(Button)``;
